import Header from "../components/Header";
import Leaderboard from "../components/Leaderboard";
import KillFeed from "../components/KillFeed";

export default function Overview() {
    return (
        <>
            <Header />
            <Leaderboard />
            <KillFeed />
        </>
    );
}